import Swal from 'sweetalert2'

export function useError(message) {
	return Swal.fire({
		title: 'ATENÇÃO!',
		customClass: {
			container: 'themed error',
		},
		html: message,
	})
}
